import { makeObservable, observable } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';

import { AppStore } from '../../../common/stores/app.store';
import { getMFELoaderUrl } from '../utils/get-mfe-loader-url';

@injectable()
export class FleetStore {
    @observable src: string;

    constructor(@inject(AppStore) private readonly appStore: AppStore) {
        makeObservable(this);

        this.src = getMFELoaderUrl(this.appStore.appConfigs.environmentTag);
    }
}
